var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ml-2",attrs:{"icon":""},on:{"click":function($event){return _vm.$store.dispatch('infoDialog',_vm.info)}}},[_c('v-icon',{attrs:{"color":"indigo darken-2"}},[_vm._v("mdi-information-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }